import { Divider, List, Stack } from '@mui/material';
import type { GetHomePageDataResponse } from '@weft/api-definition';
import { INTEGRATION_PROVIDERS } from '@weft/types';
import { withDefault } from '@weft/utils';
import React from 'react';
import { useQueryClient } from 'react-query';
import { HubSpotButton } from './HubSpotButton';
import { NetsuiteButton } from './NetsuiteButton';
import { SalesforceButton } from './SalesforceButton';
import { ConnectStripeModal } from './stripe/StripeModal';

export const HomePageSidebarIntegrationsList: React.FC = () => {
  const client = useQueryClient();
  const connectedIntegrations = withDefault(client.getQueryData<GetHomePageDataResponse>('home-page')?.homePageData.connectedIntegrations, []);

  return (
    <>

      <Stack
        component={List}
        sx={{
          width: '100%',
        }}
        divider={(
          <Divider
            orientation="horizontal"
            flexItem
          />
        )}
        gap={2}
      >
        <NetsuiteButton
          isConnected={connectedIntegrations.includes(INTEGRATION_PROVIDERS.netSuite)}
        />

        <SalesforceButton
          isConnected={connectedIntegrations.includes(INTEGRATION_PROVIDERS.salesforce)}
        />
        <ConnectStripeModal
          isConnected={connectedIntegrations.includes(INTEGRATION_PROVIDERS.stripe)}
        />
        <HubSpotButton
          isConnected={connectedIntegrations.includes(INTEGRATION_PROVIDERS.hubspot)}
        />
      </Stack>
      
    </>
  );
};